const authApi = `/api/user`
const getApi = `/api/get`
const postApi = `/api/post`
const adminApi = `/api/admin`

const AUTH = {
    LOGIN: `${authApi}/login`,
    DOCTOR_LOGIN: `${authApi}/doctor-login`,
    UPDATE_CLANIC_SETTINGS: `${authApi}/update-clanic-settings`,
    CHANGE_CLANIC_PASSWORD: `${authApi}/change-clanic-password`,
    UPDATE_DOCTOR_SETTINGS: `${authApi}/update-doctor-settings`,
    CHANGE_DOCTOR_PASSWORD: `${authApi}/change-doctor-password`,

}

const GET = {
    VERIFY_EMAIL: `${getApi}/verifyemail`,
    GET_MY_ALL_SERVICES: `${getApi}/get-my-all-services`,
    GET_MY_ALL_DOCTORS: `${getApi}/get-my-all-doctors`,
    GET_MY_ALL_ROOM: `${getApi}/get-my-all-rooms`,
    GET_CONTACT_DATA: `${getApi}/get-contact-form`,
}

const POST = {
    ADD_SERVICE_FROM: `${postApi}/add-service`,
    EDIT_SERVICE_FROM: `${postApi}/edit-service`,
    ADD_DOCTOR: `${postApi}/add-doctor`,
    EDIT_DOCTOR_FROM: `${postApi}/edit-doctor`,
    ADD_ROOM: `${postApi}/add-room`,
    EDIT_ROOM: `${postApi}/edit-room`,
    DELETE_SERVICE_FORM: `${postApi}/delete-service-form`,
    DELETE_DOCTOR: `${postApi}/delete-doctor`,
    DELETE_ROOM: `${postApi}/delete-room`,
    CREATE_CONTACT_FORM: `${postApi}/create-contact-form`,
}


const ADMIN = {
    LOGIN: `${adminApi}/login`,


}

export {
    AUTH,
    GET,
    POST,
    ADMIN
}